import {builder} from 'san-update';
import axios from 'axios';
import axiosJsonp from 'axios-jsonp';
import {loginAPI, followPOST, followGET, GUIDE_ACTION_API} from '../service/api';
import log from './log';
import tts from './tts';
import loadScript from '@/lib/utils/loadScript';

const json2Query = obj => {
    let str = [];
    for (var i in obj) {
        let value = obj[i] instanceof Object ? encodeURIComponent(JSON.stringify(json2Query(obj[i]))) : obj[i];
        str.push(`${i}=${value}`);
    }
    return str.join('&');
};
export default {
    ...log,
    ...tts,
    'news:updateLoginInfo'(data, {dispatch}) {
        if (data && data.username) {
            return builder().set('common.isLogin', true);
        }
        return builder().set('common.isLogin', false);
    },
    'news:updateTopBar'(data) {
        if (data) {
            return builder().set('topbar', {
                islogin: !!data.username,
                username: data.username,
                hideLoginInfo: false,
                avatar: data.avatar,
            });
        }
    },
    'news:updateLogin'(data, {dispatch, getState}) {
        axios({
            url: loginAPI,
            adapter: axiosJsonp,
            callbackParamName: 'cb',
        }).then(({data}) => {
            dispatch('news:updateTopBar', data);
            dispatch('news:updateLoginInfo', data);
            dispatch('news:pageShowLog');
            dispatch('follow:remoteState');
            dispatch('tts:init');
        });
    },
    // 获取当前关注状态
    'follow:remoteState'(data, {dispatch, getState}) {
        const common = getState('common');
        const isLogin = common.isLogin;
        const author = getState('header').itemData?.infoBaiJiaHao;
        if (!author) { // 非百家号文章 不做关注按钮展示
            return;
        }
        if (!isLogin) {
            dispatch('followed:change', false);
            return;
        }
        const query = {
            type: author.type || 'media',
            third_id: author.third_id,
            sfrom: 'dusite',
            store: 'uid',
            ignore_cuid: 1,
            source: 'media_detail_pc',
            ext: {
                parent: 'media_detail_pc',
            },
        };
        const url = `${followGET}?${json2Query(query)}`;
        axios({
            url,
            adapter: axiosJsonp,
            callbackParamName: 'callback',
        }).then(({data}) => {
            const followList = data.data?.items || [];
            if (+data.errno === 0) {
                const result = followList.find(d => d.third_id === author.third_id);
                dispatch('followed:change', !!result);
                dispatch('log:follow:show', !!result);
            } else {
                dispatch('log:follow:show', common.follow);
            }
        }).catch(err => {
            dispatch('log:follow:show', common.follow);
        });
    },
    'update:follow'(followed, {dispatch, getState}) {
        // const comment = getState('comment');
        const common = getState('common');
        const isLogin = common.isLogin;
        const author = getState('header').itemData?.infoBaiJiaHao;
        if (!isLogin) {
            dispatch('jump:login');
            return;
        }
        dispatch('log:follow:click', followed);
        const md5 = require('md5');
        const time = new Date().getTime();
        const token = md5(`${author.third_id}${author.type}${time}`);

        // dispatch('follow:followClkLog', isFollow);
        const query = {
            type: author.type || 'media',
            op_type: followed ? 'cancel' : 'add',
            third_id: author.third_id,
            sfrom: 'dusite',
            token,
            ignore_cuid: 1,
            source: 'media_detail_pc',
            ext: {
                parent: 'media_detail_pc',
            },
            time,
        };
        const url = `${followPOST}?${json2Query(query)}`;
        axios({
            url,
            adapter: axiosJsonp,
            callbackParamName: 'callback',
        }).then(({data}) => {
            if (!+data.errno) {
                dispatch('followed:change', !followed);
                dispatch('show:toast', {content: !followed ? '关注成功' : '取消关注成功'});
            } else {
                dispatch('show:toast', {content: data.errmsg});
            }
        }).catch(err => {
            dispatch('show:toast', {content: !followed ? '关注失败' : '取消关注失败'});
        });
    },
    'followed:change'(followed) {
        return builder().set('common.follow', followed);
    },
    'show:toast'(data) {
        if (!data.content) {
            return builder().set('toastInfo', {});
        }
        return builder().set('toastInfo', {showToast: true, content: data.content});
    },
    'hide:toast'() {
        return builder().set('toastInfo', {showToast: false, content: ''});
    },
    'jump:login'() {
        if (!window.__instance && !window.passport) {
            loadScript('//passport.baidu.com/passApi/js/uni_login_wrapper.js', () => {
                window.__instance = window.passport.pop.init({
                    loginVersion: 'v4',
                    apiOpt: {
                        staticPage: 'https://mbd.baidu.com/newspage/data/passlogin',
                        product: 'landing-pc', // 产品线标志，pp只是用于示例，请填写申请的tpl
                        u: window.location.href, // 登录成功跳转地址
                        memberPass: true, // 记住登录状态，原isMen
                        safeFlag: 0,
                    },
                    cache: true, //  缓存
                    forgetLink: '//passport.baidu.com/?getpass_index', // 忘记密码
                    registerLink: '//passport.baidu.com/v2/?reg&tpl=&u=', // 注册链接
                    authsite: ['tsina', 'weixin', 'qzone'], //  合作登录
                    tangram: true, // 如果页面不是使用的tangram2.0， 则此处配置成true,否则配置成false
                    onLoginSuccess: function (args) {
                        window.__instance.hide();
                    },
                });
                window.__instance.show();
            });
        } else {
            window.__instance.show();
        }
    },
    'news:updateBottomGuideInfo'(data, {dispatch, getState}) {
        axios.defaults.withCredentials = true;
        axios.post(GUIDE_ACTION_API, data).then(obj => {
            const data = obj.data.data;
            dispatch('news:updateBottomGuide', data.action_rule.pos_3[0]);
        });
    },
    'news:updateBottomGuide'(data) {
        if (data) {
            const storageTimeTamp = localStorage.getItem('LANDINGPAGE_BOTTOM_ACTION') || 0;
            const clickInterval = data.click_interval;
            const curTimeTamp = new Date().getTime();
            const nextShowTimeTamp = +storageTimeTamp + clickInterval * 86400000;
            let showGuideAction = true;
            // storageTimeTamp值为用户关闭活动入口时的时间戳, 下次展现的时机为, clickInterval天后
            if (curTimeTamp < nextShowTimeTamp) {
                showGuideAction = false;
            }

            return builder().set('guideAction', {
                sid: data.sid,
                posId: data.pos_3,
                actionFlag: data.action_flag,
                ext: data.ext,
                clickInterval: data.click_interval,
                qrImg: data.qr_img,
                qrTitle: data.qr_title,
                qrDesc: data.qr_desc,
                ballImg: data.ball_img,
                ballDesc: data.ball_desc,
                qrShowSec: data.qr_show_sec,
                showGuideAction,
            });
        }
    },
};
